import { MenuItem } from "@mui/material";
import FormikSelect from "../../../commons/formik/FormikSelect";

const TipoContratista = ({ opcionesContratista, values, disabled }) => {
  return (
    <FormikSelect
      fullWidth
      name="idTipoContratista"
      label="Tipo de Contratista*"
      disabled={!values.resolucion || values.resolucion === "3598" || disabled}
    >
      {opcionesContratista.map(({ id, nombre }) => {
        return (
          <MenuItem value={id} key={id}>
            {nombre}
          </MenuItem>
        );
      })}
    </FormikSelect>
  );
};

export default TipoContratista;
